import { useContext } from "react";
import { ManufacturerContext } from "./ManufacturersPage";

/**
 * Retrieves the optional manufacturer context.
 *
 * @returns {Object} The manufacturer context.
 * @throws {Error} If the manufacturer context is not provided.
 */
const useOptionalManufacturerContext = () => {
  try {
    const context = useContext(ManufacturerContext);
    if (context === undefined) {
      throw new Error("ManufacturerContext not provided");
    }
    return context;
  } catch (e) {
    return {
      manufacturers: [],
      setManufacturers: () => {},
    };
  }
};

export default useOptionalManufacturerContext;
